<template>
	<div class="relative h-screen w-full flex items-center justify-center overflow-x-hidden bg-black/60">
		<div class="absolute h-screen -z-10 overflow-x-hidden">
			<img
				class="h-screen w-screen object-cover"
				src="../assets/img/bull-in-mountains.png"
				alt=""
			/>
		</div>
		<div class="rounded-lg bg-white/60 px-4 pb-4 pt-5 text-left shadow-xl sm:my-8 sm:max-w-xl sm:p-6">
			<div>
				<div class="mt-3 sm:mt-5">
					<h3
						class="text-6xl font-semibold leading-14 text-gray-900 text-center"
						id="modal-title"
					>
						404
					</h3>
					<div class="mt-5">
						<p class="text-xl text-gray-900 text-center">
							Oops... it looks like this page does not exist. Please check the url to check if it is
							correct or contact our support team
						</p>

						<a href="https://jaquessermand.ch">
							<div
								class="w-full bg-gold py-2 text-white text-center font-bold border-2 border-gold rounded-md mt-10 transition duration-300 hover:bg-white"
							>
								Home
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// components

export default {
	name: "404",
	data() {
		return {};
	},
	mounted() {},
	methods: {},
};
</script>
